import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../../../../components/ui/dialog'
import { ChevronRight } from 'lucide-react'
import { UserRoleEnum } from '@/app/services/usersService/user'
import { cn } from '@/app/utils/cn'

interface RoleSelectionModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onRoleSelect: (role: UserRoleEnum | undefined) => void
}

interface RoleOption {
  role: UserRoleEnum
  title: string
  description: string
}

const roleOptions: RoleOption[] = [
  {
    role: UserRoleEnum.USER,
    title: 'Vendedor | Líder | Supervidor | Gerente',
    description:
      'Responsável por atuar diretamente com os clientes gerenciando todo o ciclo de vendas, desde o primeiro contato até o pós-venda.',
  },
  {
    role: UserRoleEnum.SUPPORT,
    title: 'Suporte',
    description:
      'Presta assistência técnica e operacional aos usuários ou clientes. Resolvendo problemas, e esclarecendo dúvidas',
  },
  {
    role: UserRoleEnum.ADMIN,
    title: 'Administrador',
    description:
      'monitora o desempenho de equipes e toma decisões estratégicas para otimizar os resultados',
  },
]

export function RoleSelectionModal({
  open,
  onOpenChange,
  onRoleSelect,
}: RoleSelectionModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0">
        <DialogHeader>
          <DialogTitle className="border-b p-4 text-xl font-semibold">
            Selecione o perfil de usuário
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          {roleOptions.map((option, index) => (
            <div
              key={option.title}
              onClick={() => onRoleSelect(option.role)}
              className={cn(
                'm-4 flex cursor-pointer items-center justify-between pb-4',
                index !== roleOptions.length - 1 ? 'border-b' : '',
              )}
            >
              <div className="space-y-2">
                <h4 className="text-sm font-semibold">{option.title}</h4>
                <p className="max-w-96 text-sm text-gray-500">
                  {option.description}
                </p>
              </div>
              <ChevronRight className="h-12 w-12" />
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
